import { ErrorPage, PageLoading, SettingsType, withErrorBoundary } from "adviesbox-shared";
import React, { ReactElement } from "react";
import { KlantprofielOnderwerpOptions } from "../../../.generated/forms/formstypes";
import { InvalidAdviesboxResultErrorPage } from "../../../shared/components/fetch-error-page/fetch-error-page";
import { useAdviesboxData } from "../../../shared/hooks/use-adviesbox-data";
import { mapDlTargetToKlantProfielUiField, mapKlantprofielDlToUi } from "../../infra/map-klantprofiel-scherm-dl-to-ui";
import { mapKlantprofielUiToDl } from "../../infra/map-klantprofiel-scherm-ui-to-dl";
import RenderKlantProfielScherm from "../../infra/render-klantprofiel-scherm";
import { fiscaalQuestionSpecs } from "./fiscaal-question-specs";

type RouteParams = {
  vestiging: string;
  adviesdossier: string;
};

const createUrl = (s: SettingsType, p: RouteParams): string =>
  `${s.klantdossiersFormsOrigin}/Adviesdossiers/${p.adviesdossier}/Klantprofiel/${KlantprofielOnderwerpOptions.HypotheekFiscaal}`;

const HypotheekFiscaalAjax = (): ReactElement | null => {
  const { loading, error, data, platformData, saveData } = useAdviesboxData(
    createUrl,
    p => p.adviesdossier,
    mapKlantprofielDlToUi,
    mapKlantprofielUiToDl,
    mapDlTargetToKlantProfielUiField
  );

  if (loading) {
    return <PageLoading />;
  }

  if (error) {
    return <ErrorPage error={error} data={platformData} />;
  }

  if (!data) {
    return <InvalidAdviesboxResultErrorPage />;
  }

  return (
    <RenderKlantProfielScherm {...data} schermTitle="Fiscale aftrek" specs={fiscaalQuestionSpecs} saveData={saveData} />
  );
};

HypotheekFiscaalAjax.displayName = "HypotheekFiscaalAjax";

export default withErrorBoundary(HypotheekFiscaalAjax);
